/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { gridSize } from "../../../components/theme/constants";
import { ButtonGroup } from "@atlaskit/button";
import Button from "../../../components/button";
import { FormattedMessage } from "components/i18n";
import { FormRenderProps } from "react-final-form";
import { useNavigate } from "react-router";
import { useAuth } from "../../auth";

interface Props extends FormRenderProps<any> {
  isSaving: boolean;
  isRecurring?: boolean;
  isNew: boolean;
}

const SaleEditFooter: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const { isBookkeeper } = useAuth();

  const { form, isSaving } = props;
  return (<div
    css={css`
      margin-top: ${gridSize() * 4}px;
    `}
  >
    {(isBookkeeper && form.getState().values.status !== "draft") ?
      <ButtonGroup>
        <Button appearance="primary" type="submit" isLoading={isSaving} onClick={() => {
          form.change("action", "saveDraft");
          form.submit();
        }}>
          <FormattedMessage id="sale.SaleForm.save" defaultMessage="Save" />
        </Button>
        <Button appearance="subtle" onClick={() => navigate(-1)}>
          <FormattedMessage
            id="sale.SaleForm.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ButtonGroup>
      : <ButtonGroup>
        <Button appearance="primary" type="submit" isLoading={isSaving} onClick={() => {
          form.change("action", "saveSend");
          form.submit();
        }}>
          <FormattedMessage id="sale.SaleForm.saveSend" defaultMessage="Save and send" />
        </Button>
        <Button appearance="default" type="submit" isLoading={isSaving} onClick={() => {
          form.change("action", "saveDraft");
          form.submit();
        }}>
          <FormattedMessage id="sale.SaleForm.saveDraft" defaultMessage="Save draft" />
        </Button>
        <Button appearance="subtle" onClick={() => navigate(-1)}>
          <FormattedMessage
            id="sale.SaleForm.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ButtonGroup>
    }
  </div>);
};

export default SaleEditFooter;
